module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_nhnblackpick_m.f16ec2f2389c6b13c4ca5cf2c4225fb8.png";